module.exports = __webpack_public_path__ + "img/c10.4bc3d1d4.png";